window.addEventListener("DOMContentLoaded", (event) => {
  const anchors = document.querySelectorAll('.js-anchor')
  anchors.forEach((anchor) => {
    const target = anchor.getAttribute('data-target')
    anchor.addEventListener('click', function() {
      console.log('click')
      const element = document.getElementById(target)
      window.scrollTo({
        top: element.getBoundingClientRect().top,
        behavior: 'smooth'
      });
    })
  })
})
